<div
  [ngClass]="'toaster--' + config.variant"
  class="toaster"
  role="alert"
  aria-live="assertive">
  <div *ngIf="config.icon">
    <tngh-svg-icon
      size="lg"
      [name]="config.icon"></tngh-svg-icon>
  </div>

  <div class="toaster__content">
    <span class="toaster__content__title">{{ config.title }}</span>
    <div class="toaster__content__description" [innerHTML]="config.description"></div>
  </div>

  <tngh-button
    class="toaster__close"
    label="Close"
    i18n-label="Close Toaster@@CloseToasterButton"
    variant="icon-only"
    size="sm"
    iconName="times"
    (click)="closeToasterEventHandler()"></tngh-button>
</div>
